import React from 'react';
import { Phone, Star, Clock, DollarSign, Shield } from 'lucide-react';
import Container from '../Container';
import Button from '../Button';

const FacebookLanding = () => {
  const testimonials = [
    {
      name: "Mike Johnson",
      business: "Triangle Home Services",
      content: "SEO Raleigh helped us 3x our leads in just 6 months!",
      rating: 5
    },
    {
      name: "Sarah Williams",
      business: "Raleigh Real Estate",
      content: "Best marketing investment we've ever made. Period.",
      rating: 5
    }
  ];

  const benefits = [
    {
      icon: Clock,
      title: "Fast Results",
      description: "See improvement in 90 days or less"
    },
    {
      icon: DollarSign,
      title: "Affordable Plans",
      description: "Packages starting at $299/month"
    },
    {
      icon: Shield,
      title: "Guaranteed Results",
      description: "No long-term contracts required"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <Container>
        <div className="pt-32 pb-20">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full mb-6">
              Special Facebook Offer: 50% Off First Month
            </div>

            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Get More Customers From
              <span className="text-blue-600"> Google Search</span>
            </h1>

            <p className="text-xl text-gray-600 mb-4">
              Join hundreds of local Raleigh businesses already dominating Google rankings
            </p>

            <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-blue-600 font-bold mb-8 hover:text-blue-700">
              <Phone className="h-6 w-6 mr-2" />
              (919) 271-4871
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-xl shadow-md text-center"
              >
                <div className="bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <benefit.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-xl shadow-md"
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-gray-700 mb-4">"{testimonial.content}"</p>
                <div>
                  <p className="font-semibold">{testimonial.name}</p>
                  <p className="text-gray-600">{testimonial.business}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md mx-auto">
            <h2 className="text-2xl font-bold text-center mb-6">Claim Your 50% Off Offer</h2>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Business Name"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <Button className="w-full text-lg py-4">
                Get 50% Off Now
              </Button>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FacebookLanding;